<template>
  <div>
    <el-button @click="onToggle">{{show ? 'DESTROY' : 'SHOW'}}</el-button>
    <CalendarTooltipTests v-if="show" />
  </div>
</template>

<script>
import CalendarTooltipTests from './CalendarTooltipTests'

export default {
  data: () => ({
    show: true,
  }),
  computed: {
  },
  methods: {
    onToggle() {
      this.show = !this.show
    }
  },
  components: {
    CalendarTooltipTests
  }
}
</script>
